import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTimelineSynopsisGetAsyncSlice } from './get';

export const coreTimelineSynopsisReducers = combineReducers({
	get: coreTimelineSynopsisGetAsyncSlice.asyncReducers
});

export const coreTimelineSynopsisWatchers = combineAllWatchers([ coreTimelineSynopsisGetAsyncSlice.asyncWatchers ]);
